import classNames from 'classnames';
import * as React from 'react';
import { Href } from 'redux-little-router';

import { makeGridPopupContainer } from '../../containers/GridPopup/GridPopup';
import { Bem } from '../../service/Bem/Bem';
import { TestBem } from '../../service/TestBem';
import { campaigns } from '../../typings/common';
import { GridRecommendationsData, RecommendationKey, RecommendationType } from '../../typings/recommendations';
import { GridCellContentOverflow } from '../GridCellContentOverflow/GridCellContentOverflow';
import { RecommendationCardView } from '../RecommendationCard/RecommendationCard';
import { RecommendationsTooltip, RecommendationsTooltipProps } from '../RecommendationsTooltip/RecommendationsTooltip';
import { RouteStyledLink } from '../StyledLink/StyledLink';

import './GridCampaignNameCell.css';

export interface GridCampaignNameCellProps {
    name: string;
    id: string;
    campaignUrl?: Href;
    recommendations?: {
        items: GridRecommendationsData;
        onOpenRecommendationsPopup?: () => void;
        onSubmitRecommendation?: (
            id: string,
            type: RecommendationType,
            keys: Array<RecommendationKey>,
            itemName: string
        ) => void;
        onShowRecommendation?: (view: RecommendationCardView, type: RecommendationType) => void;
    };
}

const GridPopupContainer = makeGridPopupContainer<RecommendationsTooltipProps>(RecommendationsTooltip);

export class GridCampaignNameCell extends React.Component<GridCampaignNameCellProps> {
    render() {
        const { id } = this.props;

        return (
            <div className={Bem.cls('grid-campaign-name-cell')}>
                <h3 className={Bem.cls('grid-campaign-name-cell', 'title')}>
                    {this.renderGridCellContentOverflow()}
                    {this.renderRecommendations()}
                </h3>
                <div
                    className={classNames(
                        Bem.cls('grid-campaign-name-cell', 'cid'),
                        TestBem.cls('grid-campaign-name-cell', 'cid')
                    )}
                >
                    № {id}
                </div>
            </div>
        );
    }

    private renderGridCellContentOverflow() {
        const { recommendations } = this.props;

        if (!recommendations) {
            return this.getCampaignNameContent();
        }

        return <GridCellContentOverflow>{this.getCampaignNameContent()}</GridCellContentOverflow>;
    }

    private renderRecommendations() {
        const { recommendations } = this.props;

        if (!recommendations) {
            return null;
        }

        return (
            <GridPopupContainer
                cls={Bem.cls('grid-campaign-name-cell', 'recommendations')}
                recommendations={recommendations.items.data}
                view={campaigns}
                recommendationIconType={recommendations.items.recommendationsIconType}
                onShowRecommendation={recommendations.onShowRecommendation}
                onPopupOpen={recommendations.onOpenRecommendationsPopup}
                onSubmitRecommendation={this.onSubmitRecommendation}
            />
        );
    }

    private getCampaignNameContent = () => {
        const { campaignUrl, name } = this.props;

        if (campaignUrl) {
            return (
                <RouteStyledLink href={campaignUrl} title={name} cls={Bem.cls('grid-campaign-name-cell', 'camp-link')}>
                    {name}
                </RouteStyledLink>
            );
        }

        return <span title={name}>{name}</span>;
    };

    private onSubmitRecommendation = (type: RecommendationType, keys: Array<RecommendationKey>) => {
        const { recommendations, name } = this.props;

        if (recommendations && recommendations.onSubmitRecommendation) {
            recommendations.onSubmitRecommendation(this.props.id, type, keys, name);
        }
    };
}
